<div *ngIf='sessionData' class='BillingInformation'>
  <div
    class='BillingInformation-header d-flex flex-row justify-content-between'>
    <h4 class='title__page'>Billing</h4>
    <app-button
      [color]="'blue'"
      [style]="'outline'"
      route='/messages'
      size='small'
      text='Back to Inbox'></app-button>
  </div>
  <ng-container *ngIf='billingInfo && billingInfo.paid_by !== "Manager"; else paidByManager'>
    <div class='ChangePassword-body mt-3'>
      <div class='row'>
        <div class='col col-12 col-sm-9 offset-sm-3'>
          <div
            *ngIf='formReady'
            class='BillingInformation-form p-3 p-sm-5 d-flex flex-column'>
            <div class='row'>
              <div class='col col-12'>
                <h6 class='title__page'>Credit Card</h6>
              </div>
            </div>
            <div *ngIf='!canUpdateInformation'>
              <div class='col col-12'>
                <div class='alert alert-danger'>
                  <p>You currently have an active subscription. Payment details cannot be updated</p>
                </div>
              </div>
            </div>
            <div *ngIf="sessionData.billing_status !== 'Active'" class='alert alert-danger'>
              <ng-container [ngSwitch]='sessionData.billing_status'>
                <p *ngSwitchCase="'Expired'" class='mb-0'>
                  Your card has expired. Please, update your payment details.
                </p>
                <p *ngSwitchCase="'Payment failed'" class='mb-0'>
                  The transaction has failed. Please re-confirm you payment details
                </p>
                <p *ngSwitchCase="'Missing registration'" class='mb-0'>
                  We could not find an active subscription for you account. Please, confirm you payment details
                </p>
              </ng-container>
            </div>
            <form [formGroup]='formGroup'>
              <div class='row BillingInformation-form-row'>
                <div class='col col-12 col-sm-8'>
                  <div class='BillingInformation-form-label'>
                    <p class='mb-0'>Name as it appears on card:</p>
                  </div>
                  <app-text-field
                    formControlName='card_name'
                    placeholder='Name on card'></app-text-field>
                </div>
              </div>
              <div class='row BillingInformation-form-row'>
                <div class='col col-12 col-sm-8'>
                  <div class='BillingInformation-form-label'>
                    <p class='mb-0'>Credit card number:</p>
                  </div>
                  <mat-form-field
                    *ngIf='!billingInfo || !billingInfo.card_number'>
                    <input
                      formControlName='card_number'
                      matInput
                      name='card_number' />
                  </mat-form-field>
                  <p
                    *ngIf='billingInfo && billingInfo.card_number'
                    class='BillingInformation-form-card_number mb-3'>
                    <span>XXXX</span>
                    <span>XXXX</span>
                    <span>XXXX</span>
                    <span>{{ getCardNumber() }}</span>
                  </p>
                  <app-text-field
                    *ngIf='updateCardNumber'
                    class='d-inherit mt-3 mb-3'
                    formControlName='card_number'
                    placeholder='Enter new Credit Card Number'></app-text-field>
                  <app-button
                    (click)='onUpdateCardNumber(updateCardNumber)'
                    *ngIf='billingInfo && billingInfo.card_number'
                    [style]="'outline'"
                    [text]="updateCardNumber ? 'Hide' : 'Update card number'"
                    color='blue'
                    size='thin'></app-button>
                </div>
              </div>
              <div class='row BillingInformation-form-row'>
                <div class='BillingInformation-form-label'>
                  <p class='mb-0'>Expiration date:</p>
                </div>
                <div class='row'>
                  <div class='col col-md-4'>
                    <app-select
                      [items]='months'
                      class='BillingInformation-form-button'
                      formControlName='expire_month'
                      label='Month'></app-select>
                  </div>
                  <div class='col col-md-4'>
                    <app-select
                      [items]='years'
                      class='BillingInformation-form-button'
                      formControlName='expire_year'
                      label='Year'></app-select>
                  </div>
                </div>
              </div>
              <div class='BillingInformation-form-row'>
                <div class='BillingInformation-form-label'>
                  <p class='mb-0'>Card Identification number:</p>
                </div>
                <div class='row'>
                  <div class='col col-md-4'>
                    <app-text-field
                      formControlName='cvc_code'
                      placeholder='CVC'
                      type='number'></app-text-field>
                  </div>
                  <div class='col col-md-4 d-flex align-items-center'>
                  <span
                    [popoverAnimation]='true'
                    [popoverDisabled]='false'
                    [popoverOnHover]='true'
                    [popoverPlacement]="'right'"
                    [popoverTitle]="'Card Identification Number (CID)'"
                    [popover]="
                      'Back of the card: if present, 3 digits in the signature area of the right of the credit card number'
                    "
                    class='BillingInformation-form-label-info'
                  >What's this?</span
                  >
                  </div>
                </div>
              </div>
              <div
                *ngIf='!sessionData.transaction_id && false'
                class='BillingInformation-form-row'>
                <div class='row'>
                  <div class='col col-md-4'>
                    <div class='BillingInformation-form-label'>
                      <p class='mb-0'>Team Code:</p>
                    </div>
                    <app-text-field
                      formControlName='team_code'
                      placeholder='Team Code'></app-text-field>
                  </div>
                </div>
              </div>
              <div *ngIf='showPlanSelection' class='row BillingInformation-form-row'>
                <div class='col col-6 d-flex flex-column BillingInformation-form-row-col'>
                  <mat-label>Please, select your plan</mat-label>
                  <app-select [items]='planItems'
                              formControlName='plan_id' label='Select product...'></app-select>
                </div>
              </div>
              <div class='row BillingInformation-form-row'>
                <div class='col col-6 d-flex BillingInformation-form-row-col'>
                  <app-button
                    [color]='cancelButtonProperties.color'
                    [route]='cancelButtonProperties.route'
                    [size]='cancelButtonProperties.size'
                    [style]='cancelButtonProperties.style'
                    [text]='cancelButtonProperties.text'
                    class='BillingInformation-form-button'></app-button>
                  <app-button
                    [Click]='continueButtonProperties.onClick'
                    [color]='continueButtonProperties.color'
                    [disabled]='disableContinueButton'
                    [size]='continueButtonProperties.size'
                    [style]='continueButtonProperties.style'
                    [text]='continueButtonProperties.text'
                    class='BillingInformation-form-button'></app-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #paidByManager>
    <div class='alert alert-warning'>
      <p>Your subscription is currently paid by your manager</p>
    </div>
  </ng-template>
</div>
